import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { FilterType } from '../../search/FilterData';
import InterestSerivce from '../../../service/Interest';
import StarRating from './StarRating';
import { SortOption } from '../list/data';

interface IProps {
  setShowLikeModal: (value: boolean) => void;
  selectedIdx: number;
  mode?: string;
  selectedItem?: {
    iidx: number;
    group: string;
    group_idx: number;
    level: number;
    memo: string;
  };
  getList?: (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters: any,
  ) => void;
  func?: () => void;
  offset?: number;
  sort?: SortOption;
  filters?: FilterType;
  filter?: any;
  setActiveItem: (value: number | null) => void;
  checkIsLikeItem?: (iidx: number) => void;
}

interface groupProps {
  group: string;
  group_idx: number;
}

const AddInterestItemModal = ({
  setShowLikeModal,
  selectedIdx,
  mode,
  selectedItem,
  getList,
  func,
  offset,
  sort,
  filters,
  filter,
  setActiveItem,
  checkIsLikeItem,
}: IProps) => {
  const [groupList, setGroupList] = useState<groupProps[]>([]);
  const [addCategory, setAddCategory] = useState<boolean>(false);
  const [groupName, setGroupName] = useState<string>('');
  const [selectedGroup, setSelectedGroup] = useState<string>('미분류');
  const [seletedGroupIdx, setSelectedGroupIdx] = useState<number>(0);
  const [memo, setMemo] = useState<string>('');
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [editGroupIdx, setEditGroupIdx] = useState<number | null>(null);
  const [editGroupName, setEditGroupName] = useState<string>('');
  const [level, setLevel] = useState<number>(1);

  useEffect(() => {
    if (mode === 'edit' && selectedItem) {
      setSelectedGroup(selectedItem.group);
      setSelectedGroupIdx(selectedItem.group_idx);
      setLevel(selectedItem.level);
      setMemo(selectedItem.memo);
    }
  }, [mode, selectedItem]);

  const getGroupList = async () => {
    try {
      const res = await InterestSerivce.groupList();
      setGroupList(res.data);
    } catch (error) {
      console.error('groupList 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    getGroupList();
  }, []);

  const addGroup = async () => {
    try {
      const data = {
        group: groupName,
      };
      const res = await InterestSerivce.register(data);
      getGroupList();
      setGroupName('');
    } catch (error) {
      console.error('addGroup 함수에서 에러 발생:', error);
    }
  };

  const deleteGroup = async (group_idx: number) => {
    try {
      const res = await InterestSerivce.delete(group_idx);
      getGroupList();
    } catch (error) {
      console.error('deleteGroup 함수에서 에러 발생:', error);
    }
  };

  const updateGroup = async (idx: number) => {
    const data = {
      group_idx: idx,
      group: editGroupName,
    };
    try {
      const res = await InterestSerivce.updateGroup(data);
      setEditGroupIdx(null);
      getGroupList();
      setEditGroupName('');
    } catch (error) {
      console.error('updateGroup 함수에서 에러 발생:', error);
    }
  };

  const add = async () => {
    const data = {
      iidx: selectedIdx,
      group_idx: seletedGroupIdx,
      level: level,
      memo: memo,
    };
    try {
      const res = await InterestSerivce.add(data);
      alert('관심물건이 추가되었습니다.');
      setShowLikeModal(false);
      checkIsLikeItem && checkIsLikeItem(selectedIdx);
      getList &&
        getList(
          offset || 0,
          sort || { value: 'DD', label: '매각기일 빠른순' },
          (filters ?? filter) || {},
        );
      func && func();
    } catch (error) {
      console.error('add 함수에서 에러 발생:', error);
    }
  };

  const updataItem = async () => {
    const data = {
      iidx: selectedIdx,
      memo: memo,
      group_idx: seletedGroupIdx,
      level: level,
    };

    try {
      const res = await InterestSerivce.updateInterestItem(data);
      alert('관심물건이 수정되었습니다.');
      setActiveItem(null);
      setShowLikeModal(false);
      getList &&
        getList(
          offset || 0,
          sort || { value: 'DD', label: '매각기일 빠른순' },
          (filters ?? filter) || {},
        );
    } catch (error) {
      console.error('updateItem 함수에서 에러 발생:', error);
    }
  };

  const handleEditClick = (group_idx: number, group: string) => {
    setEditGroupIdx(group_idx);
    setEditGroupName(group);
  };

  const handleGroupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditGroupName(e.target.value);
  };

  const handleDelete = (group_idx: number) => {
    window.confirm('정말 삭제하시겠습니까?') && deleteGroup(group_idx);
  };

  const handleAddInterestItem = () => {
    if (mode === 'edit') {
      updataItem();
    } else {
      add();
    }
  };

  const renderGroupList = () => {
    if (isEditMode) {
      return (
        <>
          {groupList.map((item, index) => (
            <CategoryItem key={index}>
              <CategoryItemRow>
                <img src="/assets/images/icon/star-in-circle.svg" alt="" />
                {editGroupIdx === item.group_idx ? (
                  <MemoInput
                    type="text"
                    value={editGroupName}
                    onChange={handleGroupChange}
                  />
                ) : (
                  <span>{item.group}</span>
                )}
              </CategoryItemRow>
              {item.group === '미분류' ? null : (
                <>
                  {editGroupIdx === item.group_idx ? (
                    <CategoryItemButtonBox>
                      <CategoryItemDeleteButton
                        onClick={() => {
                          setEditGroupIdx(null);
                          setEditGroupName('');
                        }}
                      >
                        취소
                      </CategoryItemDeleteButton>
                      <CategoryItemEditButton
                        onClick={() => updateGroup(item.group_idx)}
                      >
                        변경
                      </CategoryItemEditButton>
                    </CategoryItemButtonBox>
                  ) : (
                    <CategoryItemButtonBox>
                      <CategoryItemDeleteButton
                        onClick={() => {
                          handleDelete(item.group_idx);
                        }}
                      >
                        삭제
                      </CategoryItemDeleteButton>
                      <CategoryItemEditButton
                        onClick={() =>
                          handleEditClick(item.group_idx, item.group)
                        }
                      >
                        수정
                      </CategoryItemEditButton>
                    </CategoryItemButtonBox>
                  )}
                </>
              )}
            </CategoryItem>
          ))}
        </>
      );
    } else {
      return (
        <>
          {groupList.map((item, index) => (
            <CategoryItem
              key={index}
              onClick={() => {
                setSelectedGroup(item.group);
                setSelectedGroupIdx(item.group_idx);
              }}
            >
              <CategoryItemRow>
                <img src="/assets/images/icon/star-in-circle.svg" alt="" />
                <span>{item.group}</span>
              </CategoryItemRow>
              {selectedGroup === item.group && (
                <img src="/assets/images/check/signUpcheckOn.svg" alt="" />
              )}
            </CategoryItem>
          ))}
        </>
      );
    }
  };

  return (
    <Container
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Inner>
        <div>관심물건 {mode === 'edit' ? '수정' : '추가'}</div>
        <CategoryMagageButton
          onClick={() => {
            setIsEditMode(!isEditMode);
          }}
          style={{
            backgroundColor: groupList.length > 1 ? '#EAF4FF' : 'f7f7f8',
            color: groupList.length > 1 ? '#008AFF' : 'rgba(55, 56, 60, 0.16)',
          }}
        >
          <img
            src={`/assets/images/icon/${groupList.length > 1 ? 'blue-pencil' : 'gray-pencil'}.svg`}
            alt=""
          />
          <span>관심분류 관리</span>
        </CategoryMagageButton>
        <CategoryList>
          <AddCategoryItem
            onClick={() => {
              if (groupList.length >= 10) {
                alert('관심분류는 최대 10개까지 등록 가능합니다.');
              } else {
                setAddCategory(!addCategory);
              }
            }}
          >
            <img src="/assets/images/icon/plus-circle.svg" alt="" />
            <span>관심분류 추가</span>
          </AddCategoryItem>
          {addCategory && (
            <AddCategory>
              <MemoInput
                type="text"
                placeholder="관심분류명을 입력해주세요."
                value={groupName}
                onChange={(e) => {
                  const input = e.target.value;
                  const isKorean = /[가-힣]/.test(input);
                  if (isKorean && input.length <= 10) {
                    setGroupName(input);
                  } else if (!isKorean && input.length <= 20) {
                    setGroupName(input);
                  } else {
                    alert(
                      '관심분류명은 한글 10자, 영문 20자 내로만 등록 가능합니다.',
                    );
                  }
                }}
              />
              <GuideTextBox>
                <GuideText>
                  <img src="/assets/images/icon/info-gray.svg" alt="" />
                  <div>
                    관심분류명은 한글 10자, 영문 20자 내로만 등록 가능합니다.
                  </div>
                </GuideText>
                <GuideText>
                  <img src="/assets/images/icon/info-gray.svg" alt="" />
                  <div>관심분류는 최대 10개까지 등록 가능합니다.</div>
                </GuideText>
              </GuideTextBox>
              <AddCategoryButton
                onClick={() => {
                  addGroup();
                }}
              >
                추가
              </AddCategoryButton>
            </AddCategory>
          )}
          {renderGroupList()}
        </CategoryList>
        <Rating>
          <span>관심도</span>
          <StarRating level={level} setLevel={setLevel} />
        </Rating>
        <MemoInput
          type="text"
          placeholder="메모를 입력해주세요."
          value={memo}
          onChange={(e) => {
            setMemo(e.target.value);
          }}
        />
        <ButtonBox>
          <Button
            onClick={() => {
              setShowLikeModal(false);
            }}
          >
            취소
          </Button>
          <Button
            style={{ backgroundColor: '#008AFF', color: '#fff' }}
            onClick={handleAddInterestItem}
          >
            {mode === 'edit' ? '수정' : '추가'}
          </Button>
        </ButtonBox>
      </Inner>
    </Container>
  );
};

export default AddInterestItemModal;

const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  max-width: inherit;
`;
const Inner = styled.div`
  width: 100%;
  padding: 20px 16px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 700;
  color: #171e26;
`;
const CategoryMagageButton = styled.button`
  width: 100%;
  padding: 9px 16px;
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f8;
  border-radius: 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.16);
  cursor: pointer;
  border: none;
`;

const CategoryList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
const AddCategoryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
`;
const CategoryItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
`;
const CategoryItemRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
const Rating = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 700;
  color: #616161;
`;

const RatingStarBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  cursor: pointer;
`;

const MemoInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  padding: 12px 16px;

  ::placeholder {
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-weight: 500;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Button = styled.div`
  flex: 1;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  color: #616161;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;
const AddCategory = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  padding-bottom: 16px;
`;

const GuideTextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const GuideText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const AddCategoryButton = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #008aff;
  color: #008aff;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

const CategoryItemButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-weight: 500;
`;
const CategoryItemDeleteButton = styled.span`
  width: 60px;
  height: 40px;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CategoryItemEditButton = styled.span`
  width: 60px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #008aff;
  color: #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
